import { Box, InputAdornment, Stack } from '@mui/material';
import { VyDescriptionTitle } from '../../../components/new-design/data-display/VyDescriptionTitle/VyDescriptionTitle';
import { Control, Controller } from 'react-hook-form';
import { VyDivider, VyTextInput } from '../../../components/new-design/atoms';
import { CustomerAutoComplete } from '../../plans/components/CustomerAutoComplete';
import { RefundFormValues } from '../refund-form-schema';
import { FC } from 'react';
import { VyPaper } from '../../../components/new-design/data-display/VyPaper/VyPaper';
import { FixedProductNamePicker } from '../../plans/CreatePlanPage/create-plan-page-components/FixedChargesEditTable/fixed-charges-edit-table-components/FixedProductNamePicker';
import { SIZES } from '../../../components/types/sizes';
import { isEmptyString } from '@vy/utils';
import { VyDatePicker } from '../../../components/new-design/date-picker';

type CreateRefundFormContentProps = {
  control: Control<RefundFormValues>;
  catalogProductsNames: string[];
};

export const CreateRefundFormContent: FC<CreateRefundFormContentProps> = ({
  control,
  catalogProductsNames,
}) => {
  return (
    <Box sx={{
      padding: 3
    }}>
      <Stack
        divider={<VyDivider />}
        component={VyPaper}
        sx={{
          gap: 2,
          padding: 3
        }}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Box sx={{
            flex: 6
          }}>
            <VyDescriptionTitle title="Customer" />
          </Box>
          <Box sx={{
            flex: 4
          }}>
            <CustomerAutoComplete control={control} name="customerId" disableClearable />
          </Box>
        </Stack>

        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Box sx={{
            flex: 6
          }}>
            <VyDescriptionTitle title="Service name" />
          </Box>
          <Box sx={{
            flex: 4
          }}>
            <Controller
              control={control}
              name="serviceName"
              render={({ field }) => (
                <FixedProductNamePicker
                  placeholder="Service name"
                  size={SIZES.MEDIUM}
                  catalogProductsNames={catalogProductsNames}
                  {...field}
                />
              )}
            />
          </Box>
        </Stack>

        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Box sx={{
            flex: 6
          }}>
            <VyDescriptionTitle title="Amount" />
          </Box>
          <Box sx={{
            flex: 4
          }}>
            <Controller
              name="amount"
              control={control}
              render={({ field }) => (
                <VyTextInput
                  {...field}
                  fullWidth
                  type="number"
                  value={field.value ?? ''}
                  onChange={({ target: { value, valueAsNumber } }) => {
                    field.onChange(isEmptyString(value) ? undefined : valueAsNumber);
                  }}
                  placeholder="Enter amount"
                  endAdornment={<InputAdornment position="end">$</InputAdornment>}
                />
              )}
            />
          </Box>
        </Stack>

        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Box sx={{
            flex: 6
          }}>
            <VyDescriptionTitle title="Date" />
          </Box>
          <Box sx={{
            flex: 4
          }}>
            <Controller
              control={control}
              name="date"
              render={({ field }) => (
                <VyDatePicker fullWidth size={SIZES.MEDIUM} {...field} value={field.value} />
              )}
            />
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};
